import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Icon } from 'semantic-ui-react';

import styles from './HiddenPointAccrualsBadge.module.scss';

const HiddenPointAccrualsBadge = ({ templateName, className, expanded }) => {
  const [t] = useTranslation();
  const name = templateName || '';

  const fullText = useMemo(
    () =>
      t('common.pointSystemTransferHiddenDescription', {
        templateName: name,
        defaultValue:
          'Начисления сохранены в задаче, но сейчас не отображаются. Чтобы увидеть их, включите на этой доске балльную систему с шаблоном «{{templateName}}» или верните задачу на доску с этим шаблоном',
      }),
    [name, t],
  );

  const label = useMemo(
    () =>
      name
        ? t('common.pointSystemHiddenBadge', {
            templateName: name,
            defaultValue: 'Баллы · {{templateName}}',
          })
        : t('common.pointSystemHiddenBadgeShort', {
            defaultValue: 'Баллы сохранены',
          }),
    [name, t],
  );

  if (expanded) {
    return (
      <div className={classNames(styles.notice, className)}>
        <Icon name="star" className={styles.noticeIcon} />
        <span className={styles.noticeText}>{fullText}</span>
      </div>
    );
  }

  return (
    <span className={classNames(styles.badge, className)} title={fullText}>
      <Icon name="star" className={styles.icon} />
      <span className={styles.label}>{label}</span>
    </span>
  );
};

HiddenPointAccrualsBadge.propTypes = {
  templateName: PropTypes.string,
  className: PropTypes.string,
  expanded: PropTypes.bool,
};

HiddenPointAccrualsBadge.defaultProps = {
  templateName: '',
  className: undefined,
  expanded: false,
};

export default HiddenPointAccrualsBadge;
